import React, { useRef } from 'react';
import styled from 'styled-components';
import { Form, IFormApi, IFormProps } from '@hotelplan/components.common.forms';
import { useGSSContext } from '@hotelplan/fdr.lib.search.with-global-state';
import {
  useOnSearchStateChanges,
  useSearchState,
} from '@hotelplan/fdr.lib.search.with-state';
import { useCurrentSearchContext } from 'components/domain/currentSearch/CurrentSearchContext';
import WishlistSearchControlFormSkeleton from 'components/domain/wishlist/WishlistSearchControlForm.skeleton';
import { fdrMapSRLSearchControlValuesToFormState } from 'fdr/components/candidate/fdr-search/mappers/fdr-srl-response-to-state.mapper';
import { TFdrProductSrlControlStateWithType } from 'fdr/components/candidate/fdr-search/types/search-form.types';
import { useFdrWishlistControlsQuery } from 'fdr/schemas/query/wishlist/search-controls/fdr-wishlist-controls.generated';
import { IWishlistState } from './fdr-wishlist.types';
import { useFdrUpdateWishlistSearchControls } from './use-fdr-update-wishlist-search-controls';

const FormWrapper = styled(Form)(
  ({ theme }) => theme.forms.staticBannerForm
) as React.FC<IFormProps<TFdrProductSrlControlStateWithType>>;

const FdrWishlistSearchControlForm: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  const { setGSS } = useGSSContext<TFdrProductSrlControlStateWithType>();
  const { closeSearchControl } = useCurrentSearchContext();
  const formApiRef = useRef<IFormApi<TFdrProductSrlControlStateWithType>>(null);

  const {
    data: defaultSearchControlValues,
    loading: defaultSearchControlLoading,
  } = useFdrWishlistControlsQuery({ ssr: false });

  const { loading, state } = useSearchState<IWishlistState>();
  const { searchControl } = state || {};

  useOnSearchStateChanges<IWishlistState>(nextValues => {
    formApiRef.current?.setValues(nextValues.searchControl);
  });

  const defaultSearchControlFormState = fdrMapSRLSearchControlValuesToFormState(
    defaultSearchControlValues?.fdrWishlistPage?.searchControls?.controls
  );

  const refreshWishlistSearchControls = useFdrUpdateWishlistSearchControls();

  function onSubmit(nextModel: TFdrProductSrlControlStateWithType): void {
    setGSS(defaultSearchControlFormState, nextModel);
    closeSearchControl();

    refreshWishlistSearchControls(nextModel);
  }

  if ((loading || defaultSearchControlLoading) && !searchControl)
    return <WishlistSearchControlFormSkeleton />;

  return searchControl ? (
    <FormWrapper
      formApiRef={formApiRef}
      initialValues={searchControl}
      onSubmit={onSubmit}
    >
      {children}
    </FormWrapper>
  ) : null;
};

export default FdrWishlistSearchControlForm;
